// Module
var code = "<a ng-class=\"{nolink: $.loading}\" ng-click=\"$.downloadFile()\">{{$.titleText}}</a>\n";
// Exports
export default code;